import styled from '@xstyled/emotion';

export const LabelDT = styled.dt`
  font-size: xs;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 1;
`;

export const ValueDD = styled.ddBox`
  font-size: md;
  margin-left: 0;
`;
